/* @flow */

import * as React from 'react';
import PerformanceSection from './PerformanceSection';

type Props = {
  commonPlayerIds: Array<string>,
  commonTeamIds: Array<string>,
  displayOpponent?: boolean,
  displayUser?: boolean,
  displayWidget?: boolean,
  isModal?: boolean,
  isRacing?: boolean,
  items: Array<*>,
  compact?: boolean,
  diffValue: boolean
};

type State = {
  currentWidgetId: ?string
};

class Performance extends React.Component<Props, State> {
  props: Props;

  state: State = {
    currentWidgetId: undefined
  };

  static defaultProps = {
    displayOpponent: false,
    displayUser: true,
    displayWidget: false,
    isModal: false,
    isRacing: false,
    compact: false
  };

  handleWidgetClick = id => {
    this.setState(state => ({
      currentWidgetId: state.currentWidgetId === id ? undefined : id
    }));
  };

  render() {
    const {
      commonPlayerIds,
      commonTeamIds,
      diffValue,
      displayOpponent,
      displayUser,
      displayWidget,
      isModal,
      isRacing,
      items,
      compact
    } = this.props;
    const { currentWidgetId } = this.state;

    return (
      <div>
        {items.map(item => (
          <PerformanceSection
            key={item.id}
            commonPlayerIds={commonPlayerIds}
            commonTeamIds={commonTeamIds}
            compact={compact}
            currentWidgetId={currentWidgetId}
            diffValue={diffValue}
            displayOpponent={displayOpponent}
            displayUser={displayUser}
            displayWidget={displayWidget}
            entities={item.entities}
            id={item.id}
            isModal={isModal}
            isRacing={isRacing}
            name={item.name}
            onWidgetClick={this.handleWidgetClick}
            positionAbbr={item.abbr}
          />
        ))}
      </div>
    );
  }
}

export default Performance;
